import { Injectable } from '@angular/core';
import { DefaultProductList } from '@catalog/const';
import { ActiveFacet } from '@search/const';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ActiveFacetsService } from '@search/feature';
import { RoutingService } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SeoFacetsService {
  private mustIgnore$ = this.routingService
    .getRouterState()
    .pipe(map((routerState) => routerState.state.semanticRoute !== DefaultProductList.CategoryProductList));

  constructor(
    private activeFacetsService: ActiveFacetsService,
    private routingService: RoutingService,
  ) {}

  getSeoFacetText(): Observable<string> {
    return combineLatest({
      activeFacets: this.activeFacetsService.getActiveFacets(),
      mustIgnore: this.mustIgnore$,
    }).pipe(map(({ activeFacets, mustIgnore }) => (mustIgnore ? '' : this.mapFacetsToText(activeFacets))));
  }

  mapFacetsToText(activeFacets: ActiveFacet[]): string {
    const combinedFacetsByName = activeFacets
      // Отсекаем числовые фасеты, типа цены и т.п.
      .filter((facet) => facet.contentType !== 'RANGE')

      .reduce(
        (acc, facet) => {
          if (!acc[facet.name]) {
            acc[facet.name] = [];
          }

          if (facet.value.name !== 'true') {
            acc[facet.name].push(facet.value.name);
          }

          return acc;
        },
        {} as Record<string, string[]>,
      );

    const facets = Object.entries<string[]>(combinedFacetsByName).map(([name, values]) => {
      if (values.length === 0) {
        return name;
      }

      return `${name}: ${values.join(', ')}`;
    });

    return facets.join('. ');
  }
}
